import { useEffect, useState } from "react";
import SiteHeader from "@/pages/home/components/SiteHeader";
import Hero from "@/pages/home/components/Hero";
import EntryChannels from "@/pages/home/components/EntryChannels";
import AddressChange from "@/pages/home/components/AddressChange";
import GuideSteps from "@/pages/home/components/GuideSteps";
import AppDownload from "@/pages/home/components/AppDownload";
import OnlineReading from "@/pages/home/components/OnlineReading";
import Faq from "@/pages/home/components/Faq";
import Tips from "@/pages/home/components/Tips";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <EntryChannels />
        <AddressChange />
        <GuideSteps />
        <AppDownload />
        <OnlineReading />
        <Faq />
        <Tips />
      </main>
      <SiteFooter />

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="返回顶部"
        className={`fixed right-4 md:right-6 bottom-6 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center transition-all duration-300 cursor-pointer hover:bg-primary-600 ${
          showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
        }`}
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </div>
  );
}